import { apiClient } from '../services/api';

/**
 * Пуши ведут в мини-апп с ?pid=<push id> (аналитика открытий).
 * Параметр забираем и вырезаем из URL сразу при загрузке модуля — до инициализации роутера;
 * остальные параметры (?reminder=…) и hash (tgWebAppData) сохраняем.
 */
let pendingPid: number | null = null;

try {
  const url = new URL(window.location.href);
  const raw = url.searchParams.get('pid');
  if (raw !== null) {
    const n = Number(raw);
    if (Number.isInteger(n) && n > 0) pendingPid = n;
    url.searchParams.delete('pid');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }
} catch { /* noop */ }

/** Отправить отметку открытия один раз — после успешной авторизации. */
export const reportPushOpen = (): void => {
  const pid = pendingPid;
  if (pid === null) return;
  pendingPid = null;
  apiClient.markPushOpened(pid).catch(() => { /* аналитика — не критично */ });
};
